<template>
    <div class="p-6 flex flex-col gap-6">
        <template v-for="(item, index) in salaryHistoryInfo" :key="index">
            <div >
                <div class="w-full flex justify-between items-center">
                    <p class="font-body-sm-semibold">Reg Date :
                        <span> {{ dateFormatter(item.salaryRegDatetime, 'YYYY-MM-DD HH:mm') }}</span>
                    </p>
                </div>
                <div class="border-1 border-border-basic-2 rounded-3 w-full mt-2">
                    <div class="flex w-full p-4">
                        <div class="w-[8rem] c_label">PIC</div>
                        <div class="flex-1 font-body-sm-medium">{{item.pic}}</div>
                    </div>
                    <div class="flex w-full p-3 border-t-1 border-border-basic-1">
                        <div class="w-[8rem] c_label">Effective Date</div>
                        <div class="flex-1 font-body-sm-medium">{{ dateFormatter(item.effectiveDate) }}</div>
                    </div>
                    <div class="flex w-full p-3 border-t-1 border-border-basic-1">
                        <div class="w-[8rem] c_label">taxCode</div>
                        <div class="flex-1 font-body-sm-medium">
                            <div>{{ item.taxCode }}</div>
                            <span class="flex items-center gap-1 text-primary-3 ml-[-3px] mt-[2px]">
                                <DocumentIcon :width="16" :height="16" :color="'text-primary-3'"/>
                                <template v-if="item.taxFilePath">
                                    <a :href="item.taxFilePath">
                                        <span>
                                            {{ over15Charaters(item.taxFileName) }}
                                        </span>
                                    </a>
                                </template>
                                <template v-else>
                                    <span>-</span>
                                </template>
                            </span>
                        </div>
                    </div>
                    <div class="flex w-full p-3 border-t-1 border-border-basic-1">
                        <div class="w-[8rem] c_label">Basic Salary</div>
                        <div class="flex-1 font-body-sm-medium">
                            {{ decimalFormat(item.salaryAmount) }}
                            <span> {{ `(${salaryType[item.salaryAmountType]})` }} </span>
                        </div>
                    </div>
                    <div class="flex w-full p-3 border-t-1 border-border-basic-1">
                        <div class="w-[8rem] c_label">PERA Info</div>
                        <div class="flex-1 font-body-sm-medium">
                            <div>{{ item.peraYear }}/{{ item.peraType }}/{{ item.peraAmount }}</div>
                            <span class="flex items-center gap-1 text-primary-3 ml-[-3px] mt-[2px]">
                                <DocumentIcon :width="16" :height="16" :color="'text-primary-3'"/>
                                <template v-if="item.peraCertificateFilePath">
                                    <a :href="item.peraCertificateFilePath">
                                        <span>
                                            {{ over15Charaters(item.peraCertificateFileName) }}
                                        </span>
                                    </a>
                                </template>
                                <template v-else>
                                    <span>-</span>
                                </template>
                            </span>
                        </div>
                    </div>
                    <div class="flex w-full p-3 border-t-1 border-border-basic-1">
                        <div class="w-[8rem] c_label">Other Details</div>
                        <div class="flex-1 font-body-sm-medium">{{ item.otherDetails }}</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import moment from 'moment';
import { ValidateUtil } from '@/plugins/app-util';
import DocumentIcon from '@/components/design-system/icon/document.vue';

export default {
    components:{
        DocumentIcon
    },
    props: {
        modelValue: Boolean,
        employeeSeq: String,
    },
    watch: {
        modelValue(isOpen) {
            if (!isOpen) {
                return;
            }

            const self = this;
            self.getSalaryHistoryInfo();
        },
    },
    data() {
        return {
            salaryHistoryInfo: [],
            salaryType: {
                ANNUALLY: 'Annually',
                MONTHLY: 'Monthly',
                WEEKLY: 'Weekly',
                DAILY: 'Daily',
                HOURLY: 'Hourly',
            },
        };
    },
    methods: {
        over15Charaters: ValidateUtil.over15Charaters,
        getSalaryHistoryInfo() {
            const self = this;

            const url = self
                .$api('uri', 'get-employee-salary-list')
                .replace('{employeeSeq}', self.employeeSeq);

            self.$axios
                .get(url)
                .then((res) => {
                    self.salaryHistoryInfo = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        dateFormatter(date, dateFormat = 'YYYY-MM-DD') {
            if (!date) {
                return;
            }
            return moment(date).format(dateFormat);
        },
        decimalFormat(decimalNumber) {
            decimalNumber = decimalNumber || 0;
            const options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            };

            return parseFloat(decimalNumber).toLocaleString('en-US', options);
        },
    },
};
</script>
<style scoped>
table tr td {
    border-bottom: 1px solid #eaedf7;
}

table tr:nth-last-child(1) td {
    border-bottom: none;
}
</style>
